import { useState, useRef } from "react";

const GOLD = "#F9A826";
const BLUE = "#0f1729";

export default function VideoEnsino({ musica, adminMode, setMusicas, tema }) {
    const T = tema;
    const [expandido, setExpandido] = useState(false);
    const [uploading, setUploading] = useState(false);
    const videoRef = useRef(null);
    const videos = musica.videos || [];

    const uploadVideo = (file) => {
        if (!file) return;
        setUploading(true);
        const url = URL.createObjectURL(file);
        setTimeout(() => {
            setMusicas(prev => prev.map(m => {
                if (m.id !== musica.id) return m;
                const novosVideos = [...(m.videos || []), {
                    id: Date.now(),
                    url,
                    nome: file.name.replace(/\.[^.]+$/, ""),
                    tamanho: (file.size / (1024 * 1024)).toFixed(1),
                    data: new Date().toLocaleDateString('pt-BR'),
                    autor: "Admin"
                }];
                return { ...m, videos: novosVideos };
            }));
            musica.videos = [...(musica.videos || []), {
                id: Date.now(),
                url,
                nome: file.name.replace(/\.[^.]+$/, ""),
                tamanho: (file.size / (1024 * 1024)).toFixed(1),
                data: new Date().toLocaleDateString('pt-BR'),
                autor: "Admin"
            }];
            setUploading(false);
        }, 500);
    };

    const removerVideo = (id) => {
        setMusicas(prev => prev.map(m => {
            if (m.id !== musica.id) return m;
            return { ...m, videos: (m.videos || []).filter(v => v.id !== id) };
        }));
        musica.videos = (musica.videos || []).filter(v => v.id !== id);
    };

    return (
        <div style={{ marginTop: 16 }}>
            {/* Header da seção */}
            <button
                onClick={() => setExpandido(p => !p)}
                style={{
                    width: "100%", display: "flex", alignItems: "center",
                    justifyContent: "space-between", background: T.bgCard,
                    border: `1px solid ${T.borda}`, borderRadius: 14,
                    padding: "14px 16px", cursor: "pointer", marginBottom: expandido ? 10 : 0
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{
                        width: 38, height: 38, borderRadius: 10,
                        background: `linear-gradient(135deg,${GOLD},#FFD166)`,
                        display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18
                    }}>🎬</div>
                    <div style={{ textAlign: "left" }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: T.texto }}>Vídeos de Ensino</div>
                        <div style={{ fontSize: 11, color: T.textoSecundario }}>
                            {videos.length === 0 ? "Nenhum vídeo ainda" : `${videos.length} vídeo${videos.length > 1 ? "s" : ""} disponível${videos.length > 1 ? "is" : ""}`}
                        </div>
                    </div>
                </div>
                <div style={{
                    width: 28, height: 28, borderRadius: "50%",
                    background: expandido ? `${GOLD}18` : T.bgCardSecundario,
                    border: `1px solid ${expandido ? GOLD + "44" : T.borda}`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    transition: "all 0.2s",
                    transform: expandido ? "rotate(180deg)" : "rotate(0deg)",
                }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M6 9l6 6 6-6" stroke={expandido ? GOLD : T.textoSecundario} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </button>

            {expandido && (
                <div style={{ background: T.bgCard, borderRadius: 14, border: `1px solid ${T.borda}`, overflow: "hidden" }}>

                    {/* Upload — só admin */}
                    {adminMode && (
                        <div style={{ padding: "14px 16px", borderBottom: `1px solid ${T.borda}` }}>
                            <label style={{
                                display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                                background: uploading ? T.bgCardSecundario : `${GOLD}15`,
                                border: `2px dashed ${GOLD}66`, borderRadius: 12,
                                padding: "14px 0", cursor: uploading ? "default" : "pointer",
                                color: GOLD, fontWeight: 700, fontSize: 13
                            }}>
                                {uploading ? (
                                    <>
                                        <span style={{ fontSize: 16 }}>⏳</span> Carregando vídeo...
                                    </>
                                ) : (
                                    <>
                                        <span style={{ fontSize: 16 }}>📹</span> Adicionar vídeo de ensino
                                    </>
                                )}
                                <input
                                    type="file" accept="video/*" style={{ display: "none" }}
                                    disabled={uploading}
                                    onChange={e => uploadVideo(e.target.files[0])}
                                />
                            </label>
                            <div style={{ fontSize: 11, color: T.textoSecundario, textAlign: "center", marginTop: 6 }}>
                                Suporta MP4, MOV, AVI — alta resolução
                            </div>
                        </div>
                    )}

                    {/* Lista de vídeos */}
                    {videos.length === 0 ? (
                        <div style={{ padding: "30px 16px", textAlign: "center" }}>
                            <div style={{ fontSize: 40, marginBottom: 8 }}>🎬</div>
                            <div style={{ fontSize: 14, fontWeight: 600, color: T.texto, marginBottom: 4 }}>Nenhum vídeo ainda</div>
                            <div style={{ fontSize: 12, color: T.textoSecundario }}>
                                {adminMode ? "Adicione um vídeo ensinando a música acima." : "O líder ainda não adicionou vídeos."}
                            </div>
                        </div>
                    ) : (
                        <div style={{ padding: "12px 16px", display: "flex", flexDirection: "column", gap: 12 }}>
                            {videos.map((v, idx) => (
                                <VideoCard
                                    key={v.id}
                                    video={v}
                                    idx={idx}
                                    adminMode={adminMode}
                                    onRemover={() => removerVideo(v.id)}
                                    tema={T}
                                />
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

function VideoCard({ video, idx, adminMode, onRemover, tema }) {
    const T = tema;
    const [tocando, setTocando] = useState(false);
    const [fullscreen, setFullscreen] = useState(false);
    const videoRef = useRef(null);

    const togglePlay = () => {
        const v = videoRef.current;
        if (!v) return;
        if (tocando) { v.pause(); setTocando(false); }
        else { v.play(); setTocando(true); }
    };

    return (
        <>
            {/* Card do vídeo */}
            <div style={{
                background: T.bgCardSecundario, borderRadius: 14,
                border: `1px solid ${T.borda}`, overflow: "hidden"
            }}>
                {/* Preview do vídeo */}
                <div style={{ position: "relative", background: "#000", borderRadius: "14px 14px 0 0", overflow: "hidden" }}>
                    <video
                        ref={videoRef}
                        src={video.url}
                        style={{ width: "100%", maxHeight: 220, display: "block", objectFit: "cover" }}
                        onEnded={() => setTocando(false)}
                        onPause={() => setTocando(false)}
                        onPlay={() => setTocando(true)}
                        playsInline
                    />
                    {/* Overlay com controles */}
                    <div style={{
                        position: "absolute", inset: 0,
                        background: tocando ? "transparent" : "rgba(0,0,0,0.4)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        transition: "background 0.2s"
                    }}>
                        <button
                            onClick={togglePlay}
                            style={{
                                width: 56, height: 56, borderRadius: "50%",
                                background: tocando ? "rgba(0,0,0,0.3)" : GOLD,
                                border: "none", cursor: "pointer",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                fontSize: 22, boxShadow: `0 4px 20px #0006`,
                                opacity: tocando ? 0 : 1, transition: "opacity 0.2s"
                            }}
                            onMouseEnter={e => e.currentTarget.style.opacity = "1"}
                        >
                            {tocando ? "⏸" : "▶"}
                        </button>
                    </div>
                    {/* Botão fullscreen */}
                    <button
                        onClick={() => setFullscreen(true)}
                        style={{
                            position: "absolute", top: 10, right: 10,
                            background: "rgba(0,0,0,0.6)", border: "none",
                            borderRadius: 8, padding: "4px 8px", color: "white",
                            fontSize: 14, cursor: "pointer"
                        }}
                    >⛶</button>
                    {/* Badge número */}
                    <div style={{
                        position: "absolute", top: 10, left: 10,
                        background: GOLD, borderRadius: 8,
                        padding: "2px 8px", fontSize: 11, fontWeight: 700, color: BLUE
                    }}>
                        Aula {idx + 1}
                    </div>
                </div>

                {/* Info do vídeo */}
                <div style={{ padding: "12px 14px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 13, fontWeight: 700, color: T.texto, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            🎬 {video.nome || `Vídeo ${idx + 1}`}
                        </div>
                        <div style={{ fontSize: 11, color: T.textoSecundario, marginTop: 2 }}>
                            {video.autor} • {video.data} {video.tamanho && `• ${video.tamanho}MB`}
                        </div>
                    </div>
                    {adminMode && (
                        <button
                            onClick={onRemover}
                            style={{
                                background: "#fce4ec", border: "none", borderRadius: 8,
                                padding: "6px 10px", fontSize: 14, cursor: "pointer", marginLeft: 8, flexShrink: 0
                            }}
                        >🗑</button>
                    )}
                </div>
            </div>

            {/* Fullscreen modal */}
            {fullscreen && (
                <div style={{
                    position: "fixed", inset: 0, background: "#000e", zIndex: 9999,
                    display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                    <button
                        onClick={() => setFullscreen(false)}
                        style={{
                            position: "absolute", top: 20, right: 20,
                            background: "rgba(255,255,255,0.2)", border: "none",
                            borderRadius: "50%", width: 44, height: 44,
                            color: "white", fontSize: 20, cursor: "pointer", zIndex: 10
                        }}
                    >✕</button>
                    <video
                        src={video.url}
                        controls
                        autoPlay
                        style={{ maxWidth: "100%", maxHeight: "90vh", borderRadius: 12 }}
                        playsInline
                    />
                </div>
            )}
        </>
    );
}